import {BaseSyntheticEvent} from 'react';

export function stopPropagation<T extends BaseSyntheticEvent>(e: T): void {
    e.stopPropagation();
}

export function voidFunction(): void {}
